import React, { useEffect, useState } from "react";
import { makeStyles, Grid, IconButton } from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import { useQuery } from "@apollo/client";
import { GET_SCHEDULE_NEXT_PREV } from "../../../../quries/schedule";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
  },
  textSize: {
    fontSize: 40,
    fontWeight: 900,
    // lineHeight: 32,
    fontFamily: "'Noto Sans KR'",
    textAlign: "center",
  },
}));

interface SchedulePrevProps {
  month: any;
}

function SchedulePrev({ month }: SchedulePrevProps) {
  const classes = useStyles();
  const [prev, setPrev] = useState<any>(null);

  const [searchText, setSearchText] = useState<any>(null);

  const { data, loading, error } = useQuery(GET_SCHEDULE_NEXT_PREV, {
    fetchPolicy: "no-cache",

    variables: {
      sort: "schedule_date:DESC",
      where: {
        schedule_date_lt: searchText,
      },
    },
  });

  useEffect(() => {
    console.log(month);
    const origin = new Date(month);

    const monthFirstDay = new Date(origin.getFullYear(), origin.getMonth(), 1);

    console.log(monthFirstDay);

    console.log(
      "month",
      `${monthFirstDay.getFullYear()}-${monthFirstDay.getUTCMonth()}-${monthFirstDay.getDate()}`
    );

    setSearchText(
      new Date(
        monthFirstDay.getFullYear(),
        monthFirstDay.getMonth(),
        monthFirstDay.getDate()
      )
    );
    return () => {};
  }, [month]);

  useEffect(() => {
    console.log(data);
    if (data && data.schedules.length > 0) {
      const resultDate = new Date(data.schedules[0].schedule_date);
      console.log(resultDate);
      let resultYear = resultDate.getFullYear();
      let resultMonth = resultDate.getMonth();
      let linkDate = new Date(resultYear, resultMonth, 1);
      setPrev(
        `${linkDate.getFullYear()}-${
          linkDate.getMonth() + 1
        }-${linkDate.getDate()}`
      );
    }
    return () => {
      setPrev(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.schedules) {
    console.log(error);
  }

  if (data.schedules.length > 0) {
    return (
      <IconButton
        component={Link}
        to={`/schedule/month/${prev}`}
        style={
          {
            // position: "absolute",
            // right: "10rem",
            // top: "4rem",
            // paddingBottom: 16,
          }
        }
      >
        <NavigateBeforeIcon style={{ fontSize: 56 }} />
      </IconButton>
    );
  } else {
    return <div></div>;
  }
}

export default SchedulePrev;
